import React, {useState, useEffect} from "react";

import './loadingsplash.css';

import Spinner from 'react-bootstrap/Spinner';

function LoadingSplash(props) {

    const [active, setActive] = useState(false);

    useEffect(() => {

        if (props?.active) {
            setActive(true)
        } else {
            setActive(false)
        }

    }, [props?.active]);

    return <>
    
        {active ? <div class={"loading-splash d-flex flex-column justify-content-center" + (props?.absolute ? ' loading-abs': '')}>
            <Spinner animation="border" variant="secondary">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
            {props?.text ? <p class="small mt-3">{props.text}</p> : ''}
        </div> : ''}

    </>

}

export default LoadingSplash;